import { useAuth } from "@/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { Link } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { OrderListSkeleton } from "@/components/LoadingSkeleton";

const Orders = () => {
  const { user } = useAuth();

  const { data: orders, isLoading } = useQuery({
    queryKey: ["my-orders", user?.id],
    queryFn: async () => {
      if (!user) return [] as any[];
      const { data } = await supabase
        .from("orders")
        .select("id, status, total_cents, currency, created_at, paid_at")
        .eq("buyer_id", user.id)
        .order("created_at", { ascending: false });
      return data ?? [];
    },
    enabled: !!user,
  });

  return (
    <>
      <SEOHead
        title="My Orders - Bahama Marketplace"
        description="Track your orders and purchases from Bahama Marketplace. View order history and delivery status."
      />
      <main className="container mx-auto px-4 py-10">
        <h1 className="text-3xl font-heading font-bold mb-4">My Orders</h1>
        {!user && <p className="text-muted-foreground">Please log in to view your orders.</p>}
        {user && (
          <div className="rounded-xl border">
            {isLoading ? (
              <OrderListSkeleton />
            ) : !orders?.length ? (
              <div className="p-6 text-muted-foreground">No orders yet.</div>
            ) : (
              <div className="divide-y">
                {orders.map((o: any) => (
                  <Link key={o.id} to={`/orders/${o.id}`} className="flex items-center justify-between p-4 hover:bg-accent/10">
                    <div>
                      <div className="font-medium">Order #{o.id.slice(0,8)}</div>
                      <div className="text-sm text-muted-foreground">
                        {o.status}{o.paid_at ? ` · Paid ${new Date(o.paid_at).toLocaleString()}` : ` · Placed ${new Date(o.created_at).toLocaleString()}`}
                      </div>
                    </div>
                    <div className="font-semibold">{o.currency} {(o.total_cents/100).toFixed(2)}</div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        )}
      </main>
    </>
  );
};

export default Orders;